export default {
  heroTitle: 'We work with fast moving startups and medium-sized companies. We help them launch and grow the next generation of tech-driven business.',
  heroStroke: 'us',
  heroHeadline: 'About',
  heroFirstSideHeading: 'Design/Development',
  heroSecondSideHeading: 'Collaboration',
  infoColSmall: 'What we do',
  infoColLarge: 'We are',
  infoColStroke: 'full service.',
  infoColTitle: 'What we do',
  aboutUsHeadline: 'We',
  aboutUsStroke: 'App',
  aboutUsText: 'We\'re made up of skilled individuals who seek to bring our deep knowledge to a wider audience. Our shared belief about the impact of our work is what brings us together, but it\'s our principles that make sure we produce the best work possible.',
  aboutUsHeadlineSmall: 'Our story',
  infoColBody: 'We take you from idea, to finished high-grade product smoothly.'
  + ' From the initial step of hearing and reiterating on your idea. Researching and designing the best experience. Developing the most robust and efficient code. To finally making sure we have a good hand-over process, where you can safely kick back and enjoy the product you envisioned from day one.'
  + ' For each step on the way, we talk as much as you want. If you want, every day. We are agile, and we are uncompromising in delivering the best possible product for you.',
  infoColData: {
    'Design/UX': ['Research', 'User experience', 'Wireframes/prototypes', 'Design template'],
    Development: ['Frontend', 'Backend', 'Machine learning', 'Augmented Reality'],
    Maintenance: ['Hosting', 'Support', 'Project management', 'Continuous development'],
  },
  workflowStep1Title: '01. Idea',
  workflowStep1Text: 'You contact us with a great idea. We assign the right persons to the project and help reiterate on it. How can we make it more efficient. More scalable. When we\'re both content, we get busy working.',
  workflowStep2Title: '02. Research/Design',
  workflowStep2Text: 'We do research, give valuable input, create prototypes and set the design template. Great design comes from great insight.',
  workflowStep3Title: '03. Development',
  workflowStep3Text: 'Now the fun part starts. We develop the product, with careful consideration of most suitable technologies. And take care of everything, from design and frontend, to backend, hosting and support.',
  workflowStep4Title: '04. Follow up',
  workflowStep4Text: 'The last step is follow-up, and a smooth hand-over process. We\'ll stay available. And now you can kick back and enjoy your new awesome product that you envisioned from day one.',
  workflowHeadlineSmall: 'Strategy',
  workflowHeadlineLarge: 'How we',
  workflowHeadlineLargeStroke: 'do it',
  friendsHeadlineSmall: 'Clients',
  friendsHeadlineLarge: 'We are',
  friendsHeadlineLargeStroke: 'friends',
  teamMemberHeadlineSmall: 'This is us',
  teamMemberHeadlineLarge: 'We the',
};
